const CHANNEL = "care-diary-auth";
const LOCK = "cd-session";

let channel = null;
let lockDepth = 0;
let onCompanyChanged = () => {};
let onLogout = () => {};

export function setSessionHandlers({ companyChanged, logout }) {
  onCompanyChanged = companyChanged;
  onLogout = logout;
}

function getChannel() {
  if (channel || typeof BroadcastChannel === "undefined") return channel;
  channel = new BroadcastChannel(CHANNEL);
  channel.onmessage = (event) => {
    if (event.data?.type === "company-changed") onCompanyChanged();
    if (event.data?.type === "logout") onLogout();
  };
  return channel;
}

getChannel();

export function publishCompanyChanged() {
  getChannel()?.postMessage({ type: "company-changed" });
}

export function publishLogout() {
  getChannel()?.postMessage({ type: "logout" });
}

export function withSessionLock(fn) {
  if (lockDepth > 0) return Promise.resolve().then(fn);
  const run = async () => {
    lockDepth += 1;
    try {
      return await fn();
    } finally {
      lockDepth -= 1;
    }
  };
  if (typeof navigator !== "undefined" && navigator.locks?.request) {
    return navigator.locks.request(LOCK, run);
  }
  return run();
}

const NOTICE_KEY = "cd-company-notice";

export function markCompanyChanged() {
  sessionStorage.setItem(NOTICE_KEY, "1");
}

export function takeCompanyChangedNotice() {
  const value = sessionStorage.getItem(NOTICE_KEY);
  if (!value) return false;
  sessionStorage.removeItem(NOTICE_KEY);
  return true;
}
